const ToggleActionTypes = {
    TOGGLE_TEXT: 'TOGGLE_TEXT',
    TOGGLE_BACKGROUND: 'TOGGLE_BACKGROUND'
};

export default ToggleActionTypes;
